import CartDomains from './CartDomains';
import CartHostings from './CartHostings';

export default function CartOrderList({ pagedata }) {
    return (
        <div className="order-list">
            <CartDomains pagedata={pagedata} />
            <CartHostings />
        </div>
    )
}
